import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12 p-0" }
const _hoisted_4 = { class: "login-card login-dark" }
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-input position-relative" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-input position-relative" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "form-group mb-0" }
const _hoisted_13 = { class: "text-end mt-3" }
const _hoisted_14 = {
  ref: "submitButton",
  class: "btn btn-primary btn-block py-3 w-100",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Form, {
                class: "theme-form",
                ref: "loginForm",
                onSubmit: _ctx.onSubmitReset,
                "validation-schema": _ctx.resetSchema
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", null, "Bonjour M./Mme " + _toDisplayString(_ctx.userEmail), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                        _createTextVNode("Pour la première connexion, veuillez définir "),
                        _createElementVNode("br"),
                        _createTextVNode("votre propre mot de passe")
                      ], -1))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "col-form-label" }, "Nouveau Mot de passe", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Field, {
                        name: "newPassword",
                        type: _ctx.showPassword ? 'password' : 'text',
                        class: "form-control pr-5",
                        placeholder: "Entrer votre mot de passe"
                      }, null, 8, ["type"]),
                      _createElementVNode("i", {
                        class: _normalizeClass([{ 'fa fa-eye': !_ctx.showPassword, 'fa fa-eye-slash': _ctx.showPassword }, "flaticon-eye position-absolute end-0 top-50 translate-middle-y pe-2"]),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args))),
                        "aria-label": _ctx.buttonLabel
                      }, null, 10, _hoisted_8),
                      _createVNode(_component_ErrorMessage, {
                        name: "newPassword",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label" }, "Confimer le Mot de passe", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Field, {
                        name: "confirmNewPassword",
                        type: _ctx.showPassword ? 'password' : 'text',
                        class: "form-control pr-5",
                        placeholder: "confirmer votre mot de passe"
                      }, null, 8, ["type"]),
                      _createElementVNode("i", {
                        class: _normalizeClass([{ 'fa fa-eye': !_ctx.showPassword, 'fa fa-eye-slash': _ctx.showPassword }, "flaticon-eye position-absolute end-0 top-50 translate-middle-y pe-2"]),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args))),
                        "aria-label": _ctx.buttonLabel
                      }, null, 10, _hoisted_11),
                      _createVNode(_component_ErrorMessage, {
                        name: "confirmNewPassword",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", _hoisted_14, "Modifier mon mot de passe ", 512)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ])
      ])
    ])
  ]))
}